import React from "react"
import MenuMobile from "../components/MenuMobile"
import SEO from "../components/seo"
import Layout from "../components/Layout"

function MenuMobilePage() {
  return (
    <Layout>
      <SEO title="Menu Mobile" />
      <MenuMobile />
    </Layout>
  )
}

export default MenuMobilePage
